import { Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SidebarComponent } from '../dashboard/components/sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { DashboardFooterComponent } from '../dashboard/components/dashboard-footer/dashboard-footer.component';
import { Subscription } from 'rxjs';
import { NavigationService } from '../services/navigation.service';
import { EditAvatarComponent } from './components/edit-avatar/edit-avatar.component';
import { FiltersEditComponent } from './components/filters-edit/filters-edit.component';

@Component({
  selector: 'app-edit-profile',
  standalone: true,
  imports: [
    MatToolbarModule,
    SidebarComponent,
    CommonModule,
    DashboardFooterComponent,
    EditAvatarComponent,
    FiltersEditComponent
  ],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.scss'
})
export class EditProfileComponent {
  subscriptions: Subscription[] = [];
	currentRouteName: string = '';

  constructor(private _navigationService: NavigationService) {}

  ngOnInit(): void {
		const sub = this._navigationService.currentRouteName$.subscribe((route) => {
			this.currentRouteName = route;
		});
		this.subscriptions.push(sub);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((e) => e.unsubscribe());
	}
}
